import React from 'react';

import classNames from 'styles/utils/classNames';
import { formatMarketCap, formatShares, CustomColumnDef } from 'screens/Calendar';

export const createIPOColumns = (): CustomColumnDef<any>[] => [
  {
    accessorKey: 'date',
    header: 'Date',
    csvType: 'date',
  },
  {
    accessorKey: 'company',
    header: 'Company',
    cell: ({ row }) => (
      <div className="flex flex-col">
        <span className="font-medium text-white">{row.original.company}</span>
        {row.original.ticker && (
          <span className="text-xs text-gray-400">{row.original.ticker}</span>
        )}
      </div>
    ),
  },
  {
    accessorKey: 'exchange',
    header: 'Exchange',
    cell: ({ row }) => {
      const exchange = row.original.exchange;
      const exchangeColors = {
        NASDAQ: 'text-blue-400',
        NYSE: 'text-green-400',
        AMEX: 'text-purple-400',
        OTC: 'text-orange-400',
      };

      const colorClass = exchangeColors[exchange as keyof typeof exchangeColors] || 'text-gray-400';

      return <span className={classNames('rounded px-2 py-1', colorClass)}>{exchange}</span>;
    },
  },
  {
    accessorKey: 'actions',
    header: 'Status',
    cell: ({ row }) => {
      const status = row.original.actions;
      const statusColors = {
        Priced: 'text-green-500',
        Filed: 'text-blue-500',
        Withdrawn: 'text-red-500',
        Expected: 'text-yellow-500',
        Postponed: 'text-orange-500',
        Cancelled: 'text-red-600',
      };

      const colorClass = statusColors[status as keyof typeof statusColors] || 'text-gray-400';

      return <span className={classNames('rounded px-2 py-1', colorClass)}>{status}</span>;
    },
  },
  {
    accessorKey: 'shares',
    header: 'Shares',
    csvType: 'number',
    cell: ({ row }) => {
      const shares = row.original.shares;
      return shares ? formatShares(shares) : '--';
    },
  },
  {
    accessorKey: 'priceRange',
    header: 'Price Range',
    cell: ({ row }) => {
      const priceRange = row.original.priceRange;
      return priceRange ? `${priceRange}` : '--';
    },
  },
  {
    accessorKey: 'marketCap',
    header: 'Market Cap',
    csvType: 'currency-large',
    cell: ({ row }) => {
      const marketCap = row.original.marketCap;
      return marketCap ? formatMarketCap(marketCap) : '--';
    },
  },
];
